import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_CRM_PROPERTY_DEFINITION = registerQuery({
  fieldName: 'getCRMPropertyDefinition',
  args: ['objectType', 'property'],
  fetcher: ({
    objectType,
    property
  }) => {
    return http.get(`properties/v4/${objectType}/named/${property}`);
  }
});